import SSN from './SSN';

export default SSN;
